import React from 'react';

import { Container } from '@/ui';
import { ScoringCategory } from '@/features/constructorScoringCategory';
import { useScrollToTop } from '@/hooks';

export const ScoringCategoryPage = () => {
  useScrollToTop([], { behavior: 'auto' });

  return (
    <Container $paddingBottom={48}>
      <ScoringCategory />
    </Container>
  );
};
